// تنظیمات سراسری پروژه
const config = {
  // آدرس API سرور
  //API_BASE_URL:  'http://localhost:5050',
    API_BASE_URL:'https://siteapi.rafitnes.com',
  
  // آدرس‌های API
  API_ENDPOINTS: {
    LOGIN: '/api/login',
    BLOG: '/api/blog',
    CONTACT: '/api/info/contact',
    ABOUT: '/api/info/about',
    SOCIAL: '/api/info/social',
    MEDIA: '/api/media',
    LANDING: '/api/landing',
    CUSTOM_PAGES: '/api/custom-pages',
    FAQ: '/api/faq',
    TESTIMONIAL: '/api/testimonial',
    SETTINGS: '/api/settings',
  },
  
  // محدودیت‌های فایل
  FILE_LIMITS: {
    IMAGE: 200 * 1024, // 200KB
    VIDEO: 3 * 1024 * 1024, // 3MB
    LOGO: 50 * 1024, // 50KB
    TESTIMONIAL_IMAGE: 100 * 1024, // 100KB
  }
};

// تابع برای ساخت آدرس کامل API
export const getApiUrl = (endpoint) => {
  return `${config.API_BASE_URL}${endpoint}`;
};

// تابع برای دریافت آدرس کامل endpoint
export const getEndpoint = (endpointName) => {
  return getApiUrl(config.API_ENDPOINTS[endpointName]);
};

export default config; 